export default "__VITE_ASSET__DBvId3L7__"